// extracted by mini-css-extract-plugin
var _1 = "GroupDetailPreview-module__overlayLink--MIJBi";
export { _1 as "overlayLink" }
